"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var d3 = require("d3");
var _1 = require(".");
var __1 = require("..");
var element_1 = require("../element");
var geometry_1 = require("../geometry");
var colorScale = {
    gneg: "#fff",
    gpos25: "#aaa",
    gpos50: "#777",
    gpos75: "#333",
    gpos100: "#000",
    acen: "#f00",
    gvar: "#000",
};
var Chromosome = /** @class */ (function (_super) {
    __extends(Chromosome, _super);
    function Chromosome() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Chromosome.parseAttributeValue = function (attr, value) {
        switch (attr) {
            case "_direction":
                return value === "vertical" ? __1.Direction.Vertical : __1.Direction.Horizontal;
            default:
                return _super.parseAttributeValue.call(this, attr, value);
        }
    };
    Chromosome.prototype.defaultOptions = function () {
        return __assign(__assign({}, _super.prototype.defaultOptions.call(this)), { _scale: null, _scale_isFunc: false, _dataKey: null, _direction: __1.Direction.Horizontal });
    };
    Chromosome.prototype.init = function () {
        var _this = this;
        var getData = function (d) {
            var dataKey = _this.getOption("_dataKey");
            if (typeof dataKey === "string") {
                return d[dataKey];
            }
            else {
                return d;
            }
        };
        this.appendT(element_1.Rect).options({
            _role: "groupBackground",
            _inset: [0, 0],
            fill: "#fff",
        });
        this._bands = this.appendGroupT(element_1.Rect).options({
            _data: getData,
            fill: function (d) { return colorScale[d.stain]; },
        });
        this.options("_$beforeAll", function (d, i, g, h) {
            if (typeof h.get("scale") === "function") {
                return;
            }
            var isHorizontal = h.op("_direction") === __1.Direction.Horizontal;
            var width = isHorizontal ? h.geo("_width", true) : h.geo("_height", false);
            var data = getData(d);
            var scale = h.op("_scale");
            if (typeof scale !== "function") {
                scale = d3.scaleLinear()
                    .domain([d3.min(data, function (b) { return b.start; }), d3.max(data, function (b) { return b.end; })])
                    .range([0, width]);
            }
            h.set("scale", scale);
            h.set("__scale", scale.copy());
        });
    };
    Chromosome.prototype.prepare = function () {
        _super.prototype.prepare.call(this);
        var direction = this.getOption("_direction");
        var isHorizontal = direction === __1.Direction.Horizontal || direction === "hotizontal";
        var startPos = function (d, i, g, h) {
            return h.get("scale")(d.start);
        };
        var width = function (d, i, g, h) {
            var scale = h.get("scale");
            return scale(d.end) - scale(d.start);
        };
        var fullSizeLess2 = geometry_1.GeometryValue.parse("100%-2");
        this._bands.options({
            _anchor: 16 /* Left */ | 2 /* Top */,
            _x: isHorizontal ? startPos : 1,
            _y: isHorizontal ? 1 : startPos,
            _width: isHorizontal ? width : fullSizeLess2,
            _height: isHorizontal ? fullSizeLess2 : width,
        });
    };
    Chromosome.prototype.setZoomTransform = function (t, d, i, group) {
        var s = this._getRenderHelper(d, i, group).get("scale");
        var os = this._getRenderHelper(d, i, group).get("__scale");
        s.domain(t.rescaleY(os).domain());
        this._bands.markDirty(["_x"]).render();
    };
    return Chromosome;
}(_1.Component));
exports.Chromosome = Chromosome;
//# sourceMappingURL=chromosome.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/component/chromosome.js
// module id = 1155
// module chunks = 0 1